import React from "react";
import { makeStyles } from "tss-react/mui";
import { Fade } from "react-awesome-reveal";
import expImgWhite from "../../assets/svg/experience/expImgWhite.svg";
import "./Experience.css";
import { connect } from "react-redux";

type IExperienceCardProps = Partial<ReturnType<typeof mapStateToProps>> & {
  id;
  company;
  jobTitle;
  startYear;
  endYear;
};

function ExperienceCard(props: IExperienceCardProps) {
  const { theme, id, company, jobTitle, startYear, endYear } = props;

  const useStyles = makeStyles()((t) => ({
    experienceCard: {
      backgroundColor: "#ffffff",
      boxShadow: `0 6px 20px ${theme.primary30}`,
      transition: "box-shadow 200ms ease-in-out, transform 200ms ease-in-out",
      "&:hover": {
        boxShadow: `0 10px 28px ${theme.primary50}`,
        transform: "translateY(-2px)",
      },
    },
  }));

  const { classes } = useStyles();

  return (
    <Fade direction="up" triggerOnce>
      <div key={id} className={`experience-card ${classes.experienceCard}`}>
        <div className="expcard-img" style={{ backgroundColor: theme.primary }}>
          <img src={expImgWhite as unknown as string} alt="" />
        </div>
        <div className="experience-details">
          <h6 style={{ color: theme.primary }}>
            {startYear} - {endYear}
          </h6>
          <h4 style={{ color: theme.tertiary }}>{jobTitle}</h4>
          <h5 style={{ color: theme.tertiary80 }}>{company}</h5>
        </div>
      </div>
    </Fade>
  );
}

const mapStateToProps = (state) => ({
  theme: state.rootState.theme,
});

export default connect(mapStateToProps)(ExperienceCard);
